import { getCommonHeaderProps } from "PFApp/components/card_tx/card_tx.utils";
import { CardTxContentProps } from "PFApp/components/card_tx/card_tx_content.types";
import { RolePositionContent } from "PFApp/components/card_tx/content/role_position_content";
import { RolePositionFooter } from "PFApp/components/card_tx/footer/role_position_footer";
import { Header } from "PFApp/components/card_tx/header/header";
import { Status } from "PFApp/components/card_tx/status/status";

export type PositionVariantProps = Pick<
  CardTxContentProps,
  | "activity"
  | "type"
  | "isFeed"
  | "isDraft"
  | "isHotVisible"
  | "interestedIn"
  | "handleShare"
  | "handleRefetchActivities"
>;

export const PositionVariant = ({
  activity,
  type,
  isFeed,
  isDraft,
  isHotVisible,
  interestedIn,
  handleShare,
  handleRefetchActivities
}: PositionVariantProps) => {
  const commonHeaderProps = getCommonHeaderProps({
    activity,
    type,
    isFeed,
    handleShare,
    handleRefetchActivities
  });

  return (
    <>
      <Header {...commonHeaderProps} />
      <Status isPrivate={activity.private} isDraft={isDraft} />
      <RolePositionContent activity={activity} />
      <RolePositionFooter isHotVisible={isHotVisible} interestedIn={interestedIn} />
    </>
  );
};
